import * as React from 'react'
import { LightBlueBtn, RedBtn } from '.'
import { Link as RRDLink } from 'react-router-dom'
import styled from 'styled-components'

interface LinkProps {
  children: any
  to?: string
  target?: string
  disabled?: boolean
  onClick?: () => void
  light?: boolean
  clever?: boolean
  className?: string
  id?: string
}


let colorStyles = {
  'border': '#a7c9cd',
  'borderError': '#974353',
  'bg': '#d5e4e6',
  'buttonBg': '#974353',
  'buttonDisabled': '#C6A3A9'
}

export const Link = (props: LinkProps) => {
  const { children, light, to, target, onClick, disabled, className, id, clever } = props

  if(clever){
    colorStyles = {
      'border': '#FBB07F',
      'borderError': '#974154',
      'bg': '#FDD7BF',
      'buttonBg': '#040a31',
      'buttonDisabled': '#040a3199'
    }
  }

  const handleClick = (e) => {
    if (!to) e.preventDefault()
    if (onClick) onClick()
  }

  // TODO very trivial check but works
  const isExternal = !!to && to.includes('http')

  const inside = light ? (
    <CustomLightButton
      onClick={handleClick}
      disabled={disabled}
      className={className}
      id={id}
      >      
      {children}
    </CustomLightButton>
  ) : (
    <CustomRedBtn onClick={handleClick} disabled={disabled} className={className}>
      {children}
    </CustomRedBtn>
  )

  return (
    <p style={{ textAlign: 'center', margin: 0 }}>
      {isExternal ? (
        <a href={to || ''} target={target || ''} rel='noopener noreferrer'>
          {inside}
        </a>
      ) : (
        <RRDLink to={to || ''} target={target || ''}>
          {inside}
        </RRDLink>
      )}
    </p>
  )
}

export const CustomLightButton  = styled(LightBlueBtn)`
  border-color: ${(props) => (colorStyles.buttonBg)};
`

export const CustomRedBtn  = styled(RedBtn)`
  background-color: ${(props) => (colorStyles.buttonBg)};
`


export default Link



// WEBPACK FOOTER //
// ./src/components/atoms/input/buttons/Link.tsx